import React, { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import './ToolsLayout.css'
import AdSlot from './AdSlot'
import RelatedTools from './RelatedTools'
import Logo from '../../components/logo/Logo'
import { trackEvent } from '../../lib/analytics'

const ToolsLayout = ({ children }) => {
  const location = useLocation()

  useEffect(() => {
    // Firebase Analytics only auto-logs a page_view on the initial load 
    // client-side route changes between tools need to be tracked manually.
    trackEvent('tool_page_view', { path: location.pathname })
  }, [location.pathname])

  return (
    <div className="tools-layout">
      <header className="tools-header">
        <Link to="/" className="tools-brand">
          <Logo animated />
        </Link>
        <Link to="/ferramentas" className="tools-nav-link">
          Ferramentas
        </Link>
      </header>
      <main className="tools-main">
        {children}
        {location.pathname !== '/ferramentas' && (
          <RelatedTools currentPath={location.pathname} />
        )}
        <AdSlot slot="9857175260" />
      </main>
      <footer className="tools-footer">
        <p>
          Feito por <Link to="/">Jarder Silva</Link>  desenvolvedor
          Full-Stack
        </p>
        <p>
          <Link to="/privacidade" className="tools-footer-link">
            Política de Privacidade
          </Link>
        </p>
      </footer>
    </div>
  )
}

export default ToolsLayout
